<template>
  <b-col md="12" sm="12">
    <b-card no-body class="mx-4">
      <b-card-body class="p-12">
        <b-form v-on:submit.prevent="onSubmit">
          <h1 tabindex="0">Visualizar Documento</h1>
          <b-row>
            <b-col sm="12" md="5">
              <b-form-group tabindex="0" label="Título:">
                <b-input-group class="mb-3">
                  <b-form-input type="text" class="form-control" placeholder="Título" autocomplete="titulo"
                    v-model="form.titulo" disabled autofocus />
                  <b-form-invalid-feedback id="input1LiveFeedback1">Título é obrigatório.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col sm="12" md="7">
              <b-form-group tabindex="0" label="Cor do bloco de apresentação:"
                invalid-feedback='É obrigatório informar a cor do bloco de apresentação.'>
                <b-form-select tabindex="0" disabled v-model.trim="form.cor" placeholder="" class="mb-3"
                  :options='options_cor_bloco'>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="6">
              <b-form-group tabindex="0" label="Arquivo:" for="arquivo">
                <b-form-file tabindex="0" disabled id="arquivo" ref="arquivo" v-on:change="uploadFile"
                  placeholder="Escolha um arquivo..." browse-text="Selecionar" />
                <span v-if="mostra_arquivo"><a :href="form.arquivo" target="_blank">Documento</a></span>
                <b-form-invalid-feedback id="input1LiveFeedback9">Arquivo é obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6">
                <b-form-group tabindex="0" label="Situação:">
                  <b-form-radio-group disabled v-model="form.status" :options="status" />
                </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group label="Url:">
                <b-form-input type="text" class="form-control" placeholder="Url" autocomplete="url" v-model="form.url"
                  disabled autofocus />
                  <span v-if="mostra_url"><a style="color: #17a2b8; cursor: pointer;" @click="abrirDocumento(form.url)">Url</a></span>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-row>
          <b-col md="4">
            <b-button block variant="secondary" @click="navigate('/arquivos')">
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </b-col>
</template>

<script>
import Vue from 'vue'
import VueSelect from 'vue-select'
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import SessionStorage from '@/services/session-storage'

miniToastr.init()

export default {
  name: 'Cadastro',
  components: {
    VueSelect,
    Multiselect
  },
  mixins: [validationMixin],
  created() {
    this.loadArquivo(this.$route.params.id)
  },
  data() {
    return {
      loading: false,
      form: {
        titulo: '',
        cor: null,
        arquivo: null,
        status: true,
        url: ''
      },
      mostra_arquivo: false,
      mostra_url: false,
      id_conferencia: SessionStorage.get('conferencia_atual_id'),
      disable_buttons: false,
      options_cor_bloco: [
        { 'value': null, 'text': 'Selecione' },
        { 'value': 'azul', 'text': 'Azul' },
        { 'value': 'verde', 'text': 'Verde' },
        { 'value': 'amarelo', 'text': 'Amarelo' },
        { 'value': 'roxo', 'text': 'Roxo' },
        { 'value': 'vermelho', 'text': 'Vermelho' }
      ],
      status: [
        { value: true, text: 'Ativo' },
        { value: false, text: 'Inativo' }
      ],
    }
  },

  methods: {
    loadArquivo(id) {
      Vue.http.get('api/arquivos/' + id).then(response => {

        let data = response.body.data[0]

        this.form.titulo = data.titulo
        if (data.status > 0) {
          this.form.status = true
        } else {
          this.form.status = false
        }
        this.form.cor = data.cor_bloco
        if (data.arquivo !== null) {
          this.mostra_arquivo = true
        }
        this.form.arquivo = data.arquivo
        if (data.url !== null) {
          this.mostra_url = true
        }
        this.form.url = data.url

      })
    },
    abrirDocumento(documento) {
      if (documento.indexOf("http://") !== -1 || documento.indexOf("https://") !== -1) {
        window.open(documento, '_blank')
      } else {
        window.open('https://' + documento, '_blank')
      }
    },
    navigate(route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="vue-wysiwyg/dist/vueWysiwyg.css"></style>



// WEBPACK FOOTER //
// src/pages/site/interna/arquivos/ArquivosVisualizar.vue